module.exports = __webpack_public_path__ + "static/media/redux.fe29b862.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/redux.svg
// module id = 68
// module chunks = 0